import { Tools } from "@comunicare/comunicare-helper";
import { DISABLE_REASON, FHIRHelper, IPatient } from "@comunicare/comunicare-interfaces";

export class PatientHelper {
  /**
   * Reads the sub status out of the reason a patient historic entry was written with. The value
   * is stored as-is, except for OTHER, where the free text detail is stored instead - such an
   * entry cannot be traced back to a sub status this way. A patient deactivated before sub
   * statuses existed has neither.
   */
  public static getSubStatusFromReason(reason: string): DISABLE_REASON | undefined {
    return Object.values(DISABLE_REASON).find((subStatus) => reason === subStatus);
  }

  public static getIns(patient: IPatient): string {
    return patient.identifier.find(
      (identifier) => identifier.system === FHIRHelper.SYSTEM_MATRICULE_INS && !Tools.isDefined(identifier.period?.end)
    )?.value;
  }

  public static getOid(patient: IPatient): string {
    return patient.identifier.find(
      (identifier) => identifier.system === FHIRHelper.SYSTEM_MATRICULE_INS && !Tools.isDefined(identifier.period?.end)
    )?.type?.code;
  }
}
